import React from 'react';
import ManageUnitsForm from '../Forms/manage_units_form';
import { ManageDataPage } from './manageDataShared';

const COLUMNS = [
    { label: 'Name', field: 'Name' },
];

function Manage_units() {
    return (
        <ManageDataPage
            title="Manage Units"
            endpoint="get_manage_units_table"
            columns={COLUMNS}
            editable={false}
            FormComponent={ManageUnitsForm}
            searchPlaceholder="Search units..."
        />
    );
}

export default Manage_units;
